import React from "react"
import { Heading3, TextRegular } from "../../atoms/text"
import styled from "styled-components"
import { theme } from "../../../theme"
import { SoonAvailableIcon } from "../../../icons"

export type SoonAvailableProps = {
  title: string
  description: string
}

export const SoonAvailable = (props: SoonAvailableProps) => {
  const { title, description } = props
  return (
    <Root>
      <SoonAvailableIcon />
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Root>
  )
}

const Title = styled(Heading3)`
  margin-top: 20px;
  font-weight: 600;
  letter-spacing: 0.15px;
`

const Description = styled(TextRegular)`
  margin-top: ${theme.spacing.s};
  color: ${theme.color.black4};
`
const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 500px;
  justify-content: center;
`
